/* ── Contract link parser ── */
export function parseLink(raw) {
  const s = raw.trim();
  // <url=contract:SYSID//CONTRACTID>DISPLAY</url>
  const um = s.match(/<url=contract:(\d+)\/\/(\d+)>([^<]+)<\/url>/i);
  const sysId = um ? um[1] : null;
  const contractId = um ? um[2] : null;
  const display = um ? um[3].trim() : s;

  // "A >> B (60,000.00 m³) (Courier)"
  const m1 = display.match(/^(.+?)\s*>>\s*(.+?)\s*\(([\d,.]+)\s*m³\)\s*\(([^)]+)\)\s*$/);
  if (m1) return { src: m1[1].trim(), dst: m1[2].trim(), vol: parseFloat(m1[3].replace(/,/g, "")), type: m1[4].trim(), contractId, sysId };

  // "A >> B (Type)"
  const m2 = display.match(/^(.+?)\s*>>\s*(.+?)\s*\(([^)]+)\)\s*$/);
  if (m2) return { src: m2[1].trim(), dst: m2[2].trim(), vol: null, type: m2[3].trim(), contractId, sysId };

  // "A >> B"
  const m3 = display.match(/^(.+?)\s*>>\s*(.+?)$/);
  if (m3) return { src: m3[1].trim(), dst: m3[2].trim(), vol: null, type: null, contractId, sysId };

  // No route text matched. If we at least have a contractId, return it
  // (e.g. item-exchange contracts whose link text is just an item name)
  // so the caller can still run ESI verification without route analysis.
  if (contractId) return { src: null, dst: null, vol: null, type: null, contractId, sysId };

  return null;
}
